export default "__VITE_ASSET__BIYKLjkx__"